// contexts/geral/AlertContext.js
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import Alert from '../../components/alert/Alert';

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [showModalAlert, setShowModalAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');

    // Memoize a função showAlert
    const showAlert = useCallback((message, type = 'success') => {
        setAlertMessage(message);
        setAlertType(type);
        setShowModalAlert(true);
        setTimeout(() => setShowModalAlert(false), 3000);
    }, []); // Não depende de variáveis externas mutáveis

    // Memoize o valor do contexto
    const contextValue = useMemo(() => ({
        showAlert
    }), [showAlert]);

    return (
        <AlertContext.Provider value={contextValue}>
            {children}
            <Alert 
                show={showModalAlert} 
                message={alertMessage} 
                type={alertType} 
                onClose={() => setShowModalAlert(false)} 
            />
        </AlertContext.Provider>
    );
};